import { Currency } from '@/core/currency/interfaces';

const MUR: Currency = {
    name: 'Mauritian Rupee',
    demonym: 'Mauritian',
    majorSingle: 'Rupee',
    majorPlural: 'Rupees',
    codeNumeric: '480',
    symbol: 'Rs.',
    symbolNative: 'रु ',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'MUR',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default MUR;
